import styles from "./styles.module.scss";
import { ESendStatus, FC, Props } from "./typings";
import { useTranslation } from "react-i18next";

import statusService from "api/statusService";
import Attach3Icon from "assets/icons/attachments.svg?react";
import Attach4Icon from "assets/icons/hard_drive.svg?react";
import CalendarIcon from "assets/icons/calendar.svg?react";
import CaseIcon from "assets/icons/case.svg?react";
import ChatIcon from "assets/icons/chat_bubble_outline.svg?react";
import DeskIcon from "assets/icons/book.svg?react";
import InfoIcon from "assets/icons/info_icon.svg?react";
import SharedIcon from "assets/icons/share.svg?react";
import HistoryIcon from "assets/icons/history.svg?react";
import ThreadIcon from "assets/icons/view_list.svg?react";
import ChatActionsList from "components/ChatActionList";
import CommentsModal from "components/CommentsModal";
import PackageAttachmentsModal from "components/PackageAttachmentsModal";
import PackageCaseModal from "components/PackageCaseModal";
import StatusBadge from "components/StatusBadge";
import { IStatus } from "dto/IStatus";
import { useContext, useEffect, useRef, useState } from "react";
import MetricModal from "components/MetricModal";
import EDeliveryMetricSlide from "components/Registry/MessagesRegister/EDeliveryMetricSlide";
import { ItemKind } from "dto/IKindItems";
import PackageSharesModal from "components/PackageSharesModal";
import PackagesContext from "contexts/PackagesContext";
import deskService from "api/deskService";
import classNames from "classnames";
import HistoryModal from "components/HistoryModal";
import SelectFlagNew from "components/SelectFlagNew";
import ModalsManagerContext from "contexts/ModalsManager";
import { Can } from "contexts/AbilityContext";
import { Tooltip } from "@mui/material";
import Popper from "components/Popper";
import DeskActiveModal from "components/DeskActiveModal";
import PackageThreadModal from "components/PackageThreadModal";

const IconsState: FC<Props> = ({
  msg,
  keys,
  onPreview,
  onDownload,
  showCaseIcon = true,
  withoutCase = false,
  previewData,
  showStatus = true,
  keepIconPlace,
  setShowEditStatus,
  inDeskView,
  statuses,
  showMetricIcon = true,
  showThreadIcon = false,
}) => {
  const { t } = useTranslation();
  const { modals, setModals } = useContext(ModalsManagerContext);

  const [showCase, setShowCase] = useState(false);
  const [showAttachments, setShowAttachments] = useState(false);
  const [showThreadAttachments, setShowThreadAttachments] = useState(false);
  const [showActions, setShowActions] = useState(false);
  const [showCreateAction, setShowCreateAction] = useState(false);
  const [showFlags, setShowFlags] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [, setShowAttach] = useState(false);
  const [showMetric, setShowMetric] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const [showVersion, setShowVersion] = useState(false);
  const [showTask, setShowTask] = useState(false);
  const [showThread, setShowThread] = useState(false);
  const [showDeatachFromDesk, setShowDeatachFromDesk] = useState(false);
  const deskRef = useRef<HTMLDivElement>();

  function useMediaQuery(query: string): boolean {
    const [matches, setMatches] = useState(
      () => window.matchMedia(query).matches,
    );

    useEffect(() => {
      const mql = window.matchMedia(query);
      const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
      mql.addEventListener("change", handler);
      return () => mql.removeEventListener("change", handler);
    }, [query]);

    return matches;
  }

  const isMobile = useMediaQuery("(max-width: 767px)");


  useEffect(() => {
    if (!showCase) return;
    setShowAttachments(false);
    setShowActions(false);
    setShowCreateAction(false);
    setShowFlags(false);
    setShowAttach(false);
    setShowMetric(false);
    setShowShare(false);
    setShowVersion(false);

    setShowComments(false);
  }, [showCase]);

  useEffect(() => {
    if (!showAttachments) return;
    setShowCase(false);
    setShowActions(false);
    setShowCreateAction(false);
    setShowVersion(false);
    setShowFlags(false);
    setShowAttach(false);
    setShowMetric(false);
    setShowShare(false);

    setShowComments(false);
  });

  useEffect(() => {
    if (!showActions) return;
    setShowCase(false);
    setShowAttachments(false);
    setShowCreateAction(false);
    setShowFlags(false);
    setShowAttach(false);
    setShowVersion(false);
    setShowMetric(false);
    setShowShare(false);

    setShowComments(false);
  }, [showActions]);

  useEffect(() => {
    if (!showCreateAction) return;
    setShowCase(false);
    setShowAttachments(false);
    setShowActions(false);
    setShowFlags(false);
    setShowAttach(false);
    setShowMetric(false);
    setShowShare(false);
    setShowVersion(false);

    setShowComments(false);
  }, [showCreateAction]);

  useEffect(() => {
    if (!showFlags) return;
    setShowCase(false);
    setShowCreateAction(false);
    setShowAttachments(false);
    setShowActions(false);
    setShowVersion(false);
    setShowAttach(false);
    setShowMetric(false);
    setShowShare(false);

    setShowComments(false);
  }, [showFlags]);

  useEffect(() => {
    if (!showComments) return;
    setShowCase(false);
    setShowCreateAction(false);
    setShowAttachments(false);
    setShowActions(false);
    setShowVersion(false);
    setShowFlags(false);
    setShowAttach(false);
    setShowMetric(false);
    setShowShare(false);
  }, [showComments]);

  useEffect(() => {
    if (!showMetric) return;
    setShowCase(false);
    setShowCreateAction(false);
    setShowAttachments(false);
    setShowActions(false);
    setShowFlags(false);
    setShowAttach(false);
    setShowShare(false);
    setShowComments(false);
    setShowVersion(false);
  }, [showMetric]);

  useEffect(() => {
    if (!showShare) return;
    setShowCase(false);
    setShowCreateAction(false);
    setShowAttachments(false);
    setShowActions(false);
    setShowFlags(false);
    setShowAttach(false);
    setShowMetric(false);
    setShowVersion(false);
    setShowComments(false);
  }, [showShare]);
  const { packages, setPackages } = useContext(PackagesContext);
  const { mutate: setDesk } = deskService.useSetDesk();

  const removeFromDesk = () => {
    const newPacks = [...packages];
    const el = newPacks.find((p) => p.Id === msg.Id);

    if (el) {
      if (!inDeskView) {
        el.IsDeskActive = !el.IsDeskActive;
        setPackages(newPacks);
      } else {
        setPackages(newPacks.filter((x) => x.Id !== msg.Id));
      }
    }

    setDesk(
      {
        Items: [{ Id: msg.Id, Kind: msg.Kind }],
        Show: false,
      },
      {
        onError: () => {},
      },
    );
  };

  const [status, setStatus] = useState<IStatus | null>(null);
  const { mutate: setPackageStatus } = statusService.useSetStatus();

  const refe = useRef(null);

  useEffect(() => {
    if (statuses) {
      const newStatus = statuses.find((s: IStatus) => s.Id === msg.StatusId);
      setStatus(newStatus ?? null);
    }
  }, [msg, msg.StatusId, statuses]);

  const [, setSendStatus] = useState<ESendStatus | null>(null);

  useEffect(() => {
    if (msg.state) {
      const state = msg.state;

      if (
        state === ESendStatus.WAITING ||
        state === ESendStatus.PROCESSING ||
        state === ESendStatus.ERROR
      ) {
        setSendStatus(ESendStatus.PROCESSING);
        return;
      }

      if (state === ESendStatus.ERROR_NOT_RETRAYABLE) {
        setSendStatus(ESendStatus.ERROR_NOT_RETRAYABLE);
        return;
      }

      setSendStatus(ESendStatus.SENT);
      return;
    }

    const receivers = msg.Receivers;

    if (!receivers) return;

    const waiting = receivers.filter(
      (r) =>
        r.SendStatus === ESendStatus.WAITING ||
        r.SendStatus === ESendStatus.PROCESSING ||
        r.SendStatus === ESendStatus.ERROR,
    );
    const error = receivers.filter(
      (r) => r.SendStatus === ESendStatus.ERROR_NOT_RETRAYABLE,
    );

    if (error.length) {
      setSendStatus(ESendStatus.ERROR_NOT_RETRAYABLE);
      return;
    }

    if (waiting.length) {
      setSendStatus(ESendStatus.PROCESSING);
      return;
    }

    setSendStatus(ESendStatus.SENT);
  }, [msg, msg.state]);

  const handleChangeFlag = (status: IStatus) => {
    setPackageStatus({
      OwnerId: msg.Id,
      OwnerKind: msg.Kind,
      StatusId: status.Id as number,
    });

    const newPacks = [...packages];

    const el = newPacks.find((c) => c.Id === msg.Id && c.Kind === msg.Kind);

    if (el) {
      el.StatusId = status.Id;
    }

    setPackages(newPacks);
  };

  const isPisma =
    window.location.href.search("pisma") !== -1 ||
    window.location.href.search("letters") !== -1;

  return (
    <div ref={refe} className={styles.wrapper}>
      {isPisma && (
        <HistoryIcon
          onClick={() => setShowVersion(true)}
          className={styles.icon}
        />
      )}

      {showThreadIcon && (msg.Thread?.Count > 1 || keepIconPlace) && (
        <Tooltip title={msg.Thread?.Count > 1 ? t("tooltips.threadView") : null}>
          <div>
            <ThreadIcon
              onClick={() => {
                setShowThread(!showThread);
              }}
              className={classNames(
                styles.icon,
                keepIconPlace && !(msg.Thread?.Count > 1)
                  ? styles.hidden
                  : null,
              )}
            />
          </div>
        </Tooltip>
      )}

      {((!!msg?.Thread?.AttachmentsCount && msg?.Thread?.Count > 1) ||
        keepIconPlace) && (
        <Tooltip
          title={
            msg?.Thread?.AttachmentsCount > 0 && msg?.Thread?.Count > 1
              ? t("tooltips.threadAttachments")
              : null
          }
        >
          <div>
            <Attach4Icon
              onClick={(e) => {
                setShowActions(false);
                setShowCase(false);
                setShowFlags(false);
                setShowComments(false);
                setShowShare(false);
                setShowAttachments(false);
                setShowThreadAttachments(!showThreadAttachments);
                e.stopPropagation();
                return true;
              }}
              className={classNames(
                styles.icon,
                keepIconPlace &&
                  (!(msg?.Thread?.AttachmentsCount > 0) ||
                    !(msg?.Thread?.Count > 1))
                  ? styles.hidden
                  : null,
              )}
            />
          </div>
        </Tooltip>
      )}

      <Can I="accessModule" an="tasks">
        {(msg.HasTasks || keepIconPlace) && (
          <Tooltip title={msg.HasTasks ? t("tooltips.actions") : null}>
            <div>
              <CalendarIcon
                onClick={() => {
                  setShowTask(!showTask);
                }}
                className={classNames(
                  styles.icon,
                  keepIconPlace && !msg.HasTasks ? styles.hidden : null,
                )}
              />
            </div>
          </Tooltip>
        )}
      </Can>
      {(msg?.CommentsCount > 0 || keepIconPlace) && (
        <Tooltip title={msg?.CommentsCount > 0 ? t("tooltips.comments") : null}>
          <div>
            <ChatIcon
              className={classNames(
                styles.icon,
                keepIconPlace && msg?.CommentsCount === 0
                  ? styles.hidden
                  : null,
              )}
              onClick={(e) => {
                setShowFlags(false);
                setShowActions(false);
                setShowCase(false);
                setShowAttachments(false);
                setShowShare(false);
                setShowComments(!showComments);
                e.stopPropagation();
              }}
            />
          </div>
        </Tooltip>
      )}

      {(msg.IsDeskActive || keepIconPlace) && (
        <Tooltip title={msg.IsDeskActive ? t("tooltips.unpinFromDesk") : null}>
          <div ref={deskRef}>
            <DeskIcon
              onClick={() => setShowDeatachFromDesk(true)}
              className={classNames(
                styles.icon,
                keepIconPlace && !msg?.IsDeskActive ? styles.hidden : null,
              )}
            />
          </div>
        </Tooltip>
      )}

      {((msg?.Case?.Id && showCaseIcon && !withoutCase) || keepIconPlace) && (
        <Tooltip title={msg?.Case?.Id ? t("cases.case") : null}>
          <div>
            <CaseIcon
              onClick={(e) => {
                setShowActions(false);
                setShowAttachments(false);
                setShowComments(false);
                setShowCase(!showCase);
                setShowFlags(false);
                setShowShare(false);
                e.stopPropagation();
              }}
              className={classNames(
                styles.icon,
                msg?.SearchHit?.InCase ? styles.searchHit : "",
                keepIconPlace &&
                  !(msg?.Case?.Id && showCaseIcon && !withoutCase)
                  ? styles.hidden
                  : null,
              )}
            />
          </div>
        </Tooltip>
      )}

      {(!!msg?.Attachments?.length || keepIconPlace) && (
        <Tooltip
          title={
            msg?.IsPendingPayment || msg?.IsPendingStorage
              ? null
              : msg?.Attachments?.length
              ? t("tooltips.showAttachments")
              : null
          }
        >
          <div>
            <Attach3Icon
              onClick={(e) => {
                e.stopPropagation();
                // Przesyłka zablokowana (limit przesyłek / brak miejsca na dysku) —
                // załączniki niedostępne, ikona pozostaje widoczna, ale nieaktywna.
                if (msg?.IsPendingPayment || msg?.IsPendingStorage) return;
                setShowActions(false);
                setShowCase(false);
                setShowFlags(false);
                setShowComments(false);
                setShowShare(false);
                setShowAttachments(!showAttachments);
                return true;
              }}
              className={classNames(
                styles.icon,
                msg?.IsPendingPayment || msg?.IsPendingStorage
                  ? styles.disabled
                  : "",
                msg?.SearchHit?.InAttachments ? styles.searchHit : "",
                keepIconPlace && !msg?.Attachments?.length
                  ? styles.hidden
                  : null,
              )}
            />
          </div>
        </Tooltip>
      )}
      {status && showStatus && (
        <div
          onClick={() => {
            if (setShowEditStatus) {
              setShowEditStatus(true);
            } else {
              localStorage.setItem("package", JSON.stringify(msg));
              setModals({ ...modals, editStatus: true, hide: false });
            }
          }}
          className={classNames(
            styles.icon,
            msg?.SearchHit?.InStatus ? styles.searchHit : "",
          )}
        >
          <StatusBadge onRemove={() => {}} status={status} />
        </div>
      )}

      {msg.IsShared && (
        <SharedIcon
          onClick={() => {
            setShowFlags(false);
            setShowActions(false);
            setShowCase(false);
            setShowComments(false);
            setShowAttachments(false);
            setShowShare(true);
          }}
          className={styles.icon}
        />
      )}

      {showMetricIcon && (
        <Tooltip title={t("tooltips.metrics")}>
          <div>
            <InfoIcon
              onClick={() => setShowMetric(!showMetric)}
              className={styles.icon}
            />
          </div>
        </Tooltip>
      )}

      <Popper open={showTask} anchorEl={refe?.current} setOpen={setShowTask}>
        <ChatActionsList
          changeView={() => {
            setShowActions(false);
            setShowCreateAction(true);
          }}
          toggle={() => {
            setShowTask(false);
          }}
          x={0}
          y={0}
          pack={msg}
        />
      </Popper>

      <Popper
        open={showDeatachFromDesk}
        anchorEl={deskRef?.current}
        setOpen={(v) => setShowDeatachFromDesk(v)}
      >
        <DeskActiveModal
          toggle={() => setShowDeatachFromDesk(false)}
          onRemove={removeFromDesk}
        />
      </Popper>

      <Popper
        open={!!msg?.Case?.Id && showCase}
        anchorEl={refe?.current}
        setOpen={setShowCase}
      >
        <>
          {!!msg?.Case?.Id && (
            <PackageCaseModal
              toggle={setShowCase}
              CaseId={msg.Case.Id}
              Package={msg}
            />
          )}
        </>
      </Popper>

      <Popper
        open={showAttachments}
        anchorEl={refe?.current}
        setOpen={setShowAttachments}
      >
        <PackageAttachmentsModal
          keys={keys}
          toggle={setShowAttachments}
          pack={msg}
          previewData={previewData}
          onDownload={onDownload}
          onPreview={onPreview}
        />
      </Popper>

      <Popper
        open={showThreadAttachments}
        anchorEl={refe?.current}
        setOpen={setShowThreadAttachments}
      >
        <PackageAttachmentsModal
          keys={keys}
          toggle={setShowThreadAttachments}
          pack={msg}
          previewData={previewData}
          onDownload={onDownload}
          onPreview={onPreview}
          wholeThread={true}
        />
      </Popper>

      <Popper
        open={showComments}
        anchorEl={refe?.current}
        setOpen={setShowComments}
      >
        <CommentsModal toggle={() => setShowComments(false)} pack={msg} />
      </Popper>

      <Popper open={showFlags} anchorEl={refe?.current} setOpen={setShowFlags}>
        <SelectFlagNew
          onClose={() => {
            setShowFlags(false);
          }}
          initOpen
          disableControl
          onChoose={(flag) => {
            handleChangeFlag(flag!);
          }}
          selectedStatus={null}
        />
      </Popper>

      {/* E-doręczenia (wewnętrzne, rządowe, ePUAP): metryka jako panel wysuwany od prawej (slide). */}
      {(msg.Kind === ItemKind.EDeliveryMessage ||
        msg.Kind === ItemKind.GovEDeliveryMessage ||
        msg.Kind === ItemKind.EpuapMessage) &&
        showMetric && (
          <EDeliveryMetricSlide
            pack={msg}
            onClose={() => setShowMetric(false)}
          />
        )}

      {msg.Kind !== ItemKind.EDeliveryMessage &&
        msg.Kind !== ItemKind.GovEDeliveryMessage &&
        msg.Kind !== ItemKind.EpuapMessage &&
        !isMobile && (
          <Popper
            open={showMetric}
            anchorEl={refe?.current}
            setOpen={setShowMetric}
          >
            <MetricModal toggle={setShowMetric} pack={msg} />
          </Popper>
        )}

      {msg.Kind !== ItemKind.EDeliveryMessage &&
        msg.Kind !== ItemKind.GovEDeliveryMessage &&
        msg.Kind !== ItemKind.EpuapMessage &&
        isMobile &&
        showMetric && <MetricModal toggle={setShowMetric} pack={msg} />}

      {showThread && (
        <PackageThreadModal
          itemId={msg.Id}
          itemKind={msg.Kind}
          threadId={msg.Thread?.Id}
          toggle={() => setShowThread(false)}
        ></PackageThreadModal>
      )}

      <Popper
        open={showVersion}
        anchorEl={refe?.current}
        setOpen={setShowVersion}
      >
        <HistoryModal pack={msg} toggle={() => setShowVersion(false)} />
      </Popper>

      <Popper open={showShare} anchorEl={refe?.current} setOpen={setShowShare}>
        <PackageSharesModal toggle={() => setShowShare(false)} item={msg} />
      </Popper>
    </div>
  );
};

export default IconsState;
